module.exports = __webpack_public_path__ + "img/Collected.ab5739f3.svg";